import { ascendingDefined as D, compareDefined as m } from "./sort.js";
function z(n, s, o = 0, t = 1 / 0, M) {
  if (s = Math.floor(s), o = Math.floor(Math.max(0, o)), t = Math.floor(Math.min(n.length - 1, t)), !(o <= s && s <= t)) return n;
  for (M = M === void 0 ? D : m(M); t > o; ) {
    if (t - o > 600) {
      const c = t - o + 1, u = s - o + 1, w = Math.log(c), h = 0.5 * Math.exp(2 * w / 3), x = 0.5 * Math.sqrt(w * h * (c - h) / c) * (u - c / 2 < 0 ? -1 : 1), l = Math.max(o, Math.floor(s - u * h / c + x)), q = Math.min(t, Math.floor(s + (c - u) * h / c + x));
      z(n, s, l, q, M);
    }
    const f = n[s];
    let d = o, i = t;
    for (e(n, o, s), M(n[t], f) > 0 && e(n, o, t); d < i; ) {
      for (e(n, d, i), ++d, --i; M(n[d], f) < 0; ) ++d;
      for (; M(n[i], f) > 0; ) --i;
    }
    M(n[o], f) === 0 ? e(n, o, i) : (++i, e(n, i, t)), i <= s && (o = i + 1), s <= i && (t = i - 1);
  }
  return n;
}
function e(n, s, o) {
  const t = n[s];
  n[s] = n[o], n[o] = t;
}
export {
  z as default
};
